import { __toESM } from "./chunk-B4qE4VCv.mjs";
import { require_function } from "./function-CN-GVuiB.mjs";

//#region src/voidFn.ts
var import_function = /* @__PURE__ */ __toESM(require_function());
/**
* This function does nothing and exists to satisfy branches that require a function to be passed.
*
* It can take any number of arguments and will return `void`.
*
* @category Utilities
* @example
* ```ts twoslash
* import { voidFn } from '@simplisafe/ewok'
* import * as O from 'fp-ts/lib/Option.js'
* import { pipe } from 'fp-ts/lib/function.js'
*
* const _ = pipe(O.fromNullable(null), O.match(voidFn, console.log))
* ```
*/
const voidFn = (..._args) => (0, import_function.constVoid)();

//#endregion
export { voidFn };